module.exports = __webpack_public_path__ + "img/logo.53107ee5.png";